/**
 * Turn a rejected checkout request into something we can actually show the user.
 *
 * The backend answers with a Feathers error body (`{ name, message, code, ... }`) which RTK Query
 * wraps as `{ status, data }`, so the human-readable text lives at `error.data.message`.
 * `INVALID_ACCOUNT_EMAIL` in particular is actionable — the user has to correct their own email
 * address — so it is worth surfacing verbatim rather than flattening it to a generic string.
 */
export const GENERIC_CHECKOUT_ERROR =
    'We could not open the checkout page. Please try again, and contact support if this keeps happening.';

export const resolveCheckoutErrorMessage = (error: unknown): string => {
    const body = (error as { data?: unknown })?.data ?? error;
    const message = (body as { message?: unknown })?.message;

    if (typeof message === 'string' && message.trim().length > 0) {
        return message;
    }

    return GENERIC_CHECKOUT_ERROR;
};
